import React from 'react';

export const TerritoryLabel = ({ content }) => {
  const { territory } = content;

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <label style={{ color: '#292929', fontWeight: 'bold', marginRight: '5px' }}>
        Территория:
      </label>
      <div>
        {territory.map((cantonItem, index) => {
          const regionsText = cantonItem.regions
            .map((regionItem) => {
              const areasText = regionItem.areas.join(', ');
              return `${regionItem.region} (${areasText})`;
            })
            .join('; ');

          return (
            <div
              key={index}
              style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px #3d3d3d' }}
            >
              {cantonItem.canton}, {regionsText}
            </div>
          );
        })}
      </div>
    </div>
  );
};

 